import { fmtDate } from "@/lib/format";

const CATS = ["Adult", "Youth", "Child"];
const fee = (r) => Number(r.fee_amount || 0);

export function eventTotals(regs) {
  const by = {};
  regs.forEach((r) => {
    const e = (by[r.event_name || "Event"] ||= { n: 0, paid: 0, fees: 0, income: 0, c: Object.fromEntries(CATS.map((k) => [k, { n: 0, income: 0 }])) });
    const cat = e.c[CATS.includes(r.fee_category) ? r.fee_category : "Adult"];
    e.n += 1; e.fees += fee(r); cat.n += 1;
    if (r.paid) { e.paid += 1; e.income += fee(r); cat.income += fee(r); }
  });
  const body = Object.entries(by).sort(([a], [b]) => a.localeCompare(b))
    .map(([name, e]) => [name, ...CATS.flatMap((k) => [e.c[k].n, e.c[k].income]), e.n, e.paid, e.fees, e.income, e.fees - e.income]);
  const head = ["Event", ...CATS.flatMap((k) => [k, `${k} paid income`]), "Registered", "Paid", "Total fees", "Paid income", "Still owed"];
  const foot = ["TOTAL", ...head.slice(1).map((_, i) => body.reduce((a, r) => a + r[i + 1], 0))];
  return { title: "Registration Totals by Event", head, body, foot, moneyCols: [2, 4, 6, 9, 10, 11] };
}

export function unpaidByChurch(regs) {
  const by = {};
  regs.filter((r) => !r.paid).forEach((r) => {
    const c = (by[r.church_name || "No church"] ||= { n: 0, owed: 0, names: [], events: new Set() });
    c.n += 1; c.owed += fee(r); c.names.push(r.member_name); c.events.add(r.event_name);
  });
  const body = Object.entries(by).sort((a, b) => b[1].owed - a[1].owed).map(([name, c]) => [name, [...c.events].join(", "), c.names.join(", "), c.n, c.owed]);
  return { title: "Unpaid Registrations by Church", head: ["Church", "Event", "Unpaid members", "Unpaid", "Still owed"], body, foot: ["TOTAL", "", "", body.reduce((a, r) => a + r[3], 0), body.reduce((a, r) => a + r[4], 0)], moneyCols: [4] };
}

const byChurchOrder = (churches) => {
  const order = Object.fromEntries(churches.map((c, i) => [c.id, i]));
  return (a, b) => (order[a.church_id] ?? 999) - (order[b.church_id] ?? 999) || (a.created_at || "").localeCompare(b.created_at || "");
};

export function regRecords(regs, churches) {
  const rows = [...regs].sort(byChurchOrder(churches));
  const paid = rows.filter((r) => r.paid);
  return {
    title: "Conference Registration Records",
    head: ["Date", "Church", "Event", "Name", "Category", "Fee", "Paid / Unpaid"],
    body: rows.map((r) => [fmtDate(r.created_at), r.church_name, r.event_name, r.member_name, r.fee_category || "Adult", fee(r), r.paid ? "Paid" : "Unpaid"]),
    foot: ["", "TOTAL", "", `${rows.length} registered`, `${paid.length} paid`, rows.reduce((a, r) => a + fee(r), 0), `${rows.length - paid.length} unpaid`],
    moneyCols: [5],
  };
}

export function regByChurch(regs, churches) {
  const by = new Map();
  [...regs].sort(byChurchOrder(churches)).forEach((r) => {
    const c = by.get(r.church_id) || { name: r.church_name, n: 0, paid: 0, fees: 0, income: 0 };
    c.n += 1; c.fees += fee(r);
    if (r.paid) { c.paid += 1; c.income += fee(r); }
    by.set(r.church_id, c);
  });
  const body = [...by.values()].map((c, i) => [i + 1, c.name, c.n, c.paid, c.n - c.paid, c.fees, c.income, c.fees - c.income]);
  const foot = ["", "TOTAL", ...[2, 3, 4, 5, 6, 7].map((i) => body.reduce((a, r) => a + r[i], 0))];
  return { title: "Conference Registration by Church", head: ["#", "Church", "Registered", "Paid", "Unpaid", "Expected fees", "Paid amount", "Still owed"], body, foot, moneyCols: [5, 6, 7] };
}

export const regPaidByChurch = (regs) => regs.filter((r) => r.paid).reduce((m, r) => ({ ...m, [r.church_id]: (m[r.church_id] || 0) + fee(r) }), {});
